export default __webpack_public_path__ + "static/media/36I-102699_-15669_0.3dfd4ad8.jpg";